/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import api from '../../services/api';
import Modal from '../Modal';
import { Recaptcha } from '../Recaptcha';

interface IComponent {
  handle: any;
}
interface IButtonReCaptcha {
  component: (e: IComponent) => any;
  onClick: any;
  modalTitle: string;
  disabled: boolean;
}

const ButtonReCaptcha: React.FC<IButtonReCaptcha> = ({
  component,
  onClick,
  modalTitle,
  disabled,
}) => {
  const [show, setShow] = React.useState(false);

  const removeCaptchaCode = React.useCallback(() => {
    delete api.defaults.headers.Recaptcha;
  }, []);

  return (
    <>
      {show && (
        <Modal
          handleClose={() => setShow(false)}
          show={show}
          title={modalTitle}
        >
          <Recaptcha
            callback={(data: any) => {
              onClick(data, () => removeCaptchaCode());
              setShow(false);
            }}
          />
        </Modal>
      )}
      {component({
        handle: () => {
          if (disabled) {
            onClick(undefined, () => undefined);
          } else {
            removeCaptchaCode();
            setShow(true);
          }
        },
      })}
    </>
  );
};

export { ButtonReCaptcha };
